import { buttonBaseClasses, tabClasses, type Theme } from "@mui/material"
import { OffersWidgetTheme } from "core/themes/src/definitions/components.types"

export const createOffersWidgetTheme = (theme: Theme): OffersWidgetTheme => ({
    styleOverrides: {
        root: {
            flex: "0 0 100%",
        },
        tabs: {
            [theme.breakpoints.up("xl")]: {
                [`.${buttonBaseClasses.root}.${tabClasses.root}`]: {
                    fontSize: theme.typography.fontSize + 2,
                    padding: "12px 14px",
                },
            },
        },
        detailsButton: {
            position: "absolute",
            bottom: "1em",
            left: "1em",
        },
    },
    defaultProps: {
        hideTitle: true,
    },
})
